import { Injectable } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { APIService } from '@fry/lib/api';

import { TranslationSection } from '../translation-section/translation-section.object';


@Injectable()
export class TranslationFormService {
  constructor(
    private api: APIService,
    private fb: FormBuilder
  ) {

  }

  getSections$(docType: string, objectId: string, languageCode: string): Observable<TranslationSection[]> {
    return this.api.get(`/translations/${docType}/${objectId}/${languageCode}`).pipe(
      map(data => data['sections'])
    );
  }

  saveSections$(docType: string, objectId: string, languageCode: string, translationConfig, formValue: any): Observable<TranslationSection[]> {
    const sections = this.serializeFormValue(translationConfig, formValue);
    return this.api.put(`/translations/${docType}/${objectId}/${languageCode}`, {sections: sections}).pipe(
      map(data => data['sections'])
    );
  }

  parseSections(sections: TranslationSection[]) {
    return sections.map(section =>
      this.parseSection(section, 0)
    )
  }

  parseSection(section: TranslationSection, level: number): TranslationSection {

    const translations = section['translations'] ?? [];
    return {
      id: section['id'],
      title: section['title'],
      level,
      translations: translations.map(translation => {
        return {
          msgId: translation['msgId'],
          msgStr: translation['msgStr'],
          label: translation['foundInLabels'].join(', '),
          confirmed: translation['confirmedByHuman'],
          fieldType: translation['fieldType']
        }
      }),
      sections: section['sections'].map(subSection =>
        this.parseSection(subSection, level + 1)
      )
    }
  }

  serializeFormValue(translationConfig, formValue): any {
    return translationConfig.map((sectionConfig, i) => this.serializeSectionValue(sectionConfig, formValue[i]))
  }

  serializeSectionValue(sectionConfig, sectionFormValue): any {
    return {
      id: sectionConfig['id'],
      translations: sectionConfig['translations'].map((translation, i) => {
        return {
          msgId: translation['msgId'],
          msgStr: sectionFormValue['translations'][i]['msgStr'],
          confirmedByHuman: sectionFormValue['translations'][i]['confirmed']
        }
      }),
      sections: sectionConfig['sections'].map((section, i) =>
        this.serializeSectionValue(section, sectionFormValue['sections'][i])
      )
    }
  }

  getForm(translationConfig) {
    return this.fb.array(translationConfig.map(sectionConfig => this.getSectionForm(sectionConfig)));
  }

  getSectionForm(sectionConfig) {
    return this.fb.group({
      translations: this.fb.array(sectionConfig['translations'].map(translationField =>
        this.fb.group({
          msgStr: this.fb.control(translationField['msgStr']),
          confirmed: this.fb.control(translationField['confirmed']),
        })
      )),
      sections: this.fb.array(sectionConfig.sections.map(section => this.getSectionForm(section)))
    });
  }
}
